import { render } from "./body-wrapper.vue?vue&type=template&id=c6f25bfc"
import script from "./body-wrapper.vue?vue&type=script&lang=ts"
export * from "./body-wrapper.vue?vue&type=script&lang=ts"
script.render = render

export default script